<template>
  <div class="animated fadeIn">
    <template v-if="stat">
      <ibox>
        <ibox-title>
          Рейтинг пользователей
        </ibox-title>
        <ibox-content>
          <b-table striped hover bordered responsive :fields="tableFields" :items="stat">
            <template v-slot:cell(average)="data">
              <b-progress :variant="getVariant(data.item.average * 100)" animated show-progress v-if="data.item.average" :max="100">
                <b-progress-bar :value="data.item.average * 100" :label="`${(data.item.average * 100).toFixed(0)}%`"></b-progress-bar>
              </b-progress>
            </template>
          </b-table>
        </ibox-content>
      </ibox>
    </template>
    <template v-else>
      <ibox></ibox>
      <ibox-title :hide-tools="true" class="text-center">
        <span class="text-muted">Для получения данных необходимо выбрать проект и нажать &laquo;Применить&raquo;</span>
      </ibox-title>
    </template>
  </div>
</template>

<script>
import bus from "../../bus";
import IboxTitle from "../Ibox/IboxTitle";
import IboxContent from "../Ibox/IboxContent";
import Ibox from "../Ibox/Ibox";

export default {
name: "CodifiersRating",
  components: {IboxContent, IboxTitle, Ibox},
  props: ['filters'],
  data() {
    return {
      stat: null,
      pagination: {
        limit: 30,
        offset: 0
      },
      currentPage: 1,
      tableFields: [
        {
          key: 'codifierName',
          label: 'Категория'
        },
        {
          key: 'codifierElementName',
          label: 'Компетенция/Тема'
        },
        {
          key: 'average',
          label: 'Результат'
        }
      ],
    }
  },
  methods: {
    getVariant(mark) {
      if(mark <= 50) {
        return 'danger';
      }
      if(mark <= 80) {
        return 'warning';
      }
      return 'primary';
    },
    getData() {
      this.filters.limit = this.pagination ? this.pagination.limit : null;
      this.filters.offset = this.pagination ? (this.currentPage * this.pagination.limit) - this.pagination.limit : null;
      this.axios.post(`/analytics/codifiers`, this.filters).then(res => {
        if(res.status === 200) {
          this.stat = res.data;
        } else {
          this.stat = null
        }
      })
      .catch(() => {
        this.stat = null
      })
    }
  },
  mounted() {
    bus.$on('filter-changed', () => {
      this.getData();
    });
    bus.$on('filter-cleared', () => {
      this.stat = null
    });
  }
}
</script>

<style scoped>

</style>
